<!-- <nav id="sidebar">
    <div class="sidebar-header">
        <img src="assets/images/nrlm.png" style="margin-left:15px;">
    </div>
    <ul class="list-unstyled components" id="demo">
        <li>
            <a href="#adminSubmenu" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle" aria-controls="adminSubmenu">
                <i class="fas fa-user fs-11" aria-hidden="true"></i>&nbsp;
                Producer Group
            </a>
            <ul class="collapse list-unstyled" id="adminSubmenu">
                <li>
                    <a routerLink='/layout/producerGroup/onBoardingList' ><i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;On-Boarding</a>
                </li>
                <li>
                    <a ><i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;Buss. Plan Submission</a>
                </li>
                <li>
                    <a routerLink='/layout/producerGroup/memberProfileList'><i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;Member Profile</a>
                </li>
            </ul>
        </li>
        <li>
            <a href="#funds" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                <i class="fas fa-user fs-11"></i>&nbsp;
                Fund Tracker
            </a>
            <ul class="collapse list-unstyled" id="funds">
                <li>
                    <a href="fund-requisition-submission-list.html"><i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;Fund Req. Submission</a>
                </li>
                <li>
                    <a href="fund-disbursement-list.html"><i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;Fund Disbursement</a>
                </li>
                        
                    </ul>
                </li>
        <li>
            <a href="#fisSubmenu" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                <i class="fas fa-user fs-11"></i>&nbsp;
                Produce Aggregation
            </a>
            <ul class="collapse list-unstyled" id="fisSubmenu">
                <li>
                            <a href="produce-aggregation-list.html"><i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;Agg. Of Produce</a>
                        </li>
                        <li>
                            <a href="sale-produce-list.html"><i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;Sale Of Produce</a>
                        </li>
                        <li>
                            <a href="#"><i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;Payments</a>
                        </li>
                    </ul>
                </li>
                <li>
            <a href="#remmenu" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                <i class="fas fa-user fs-11"></i>&nbsp;
                Revenue & Expense Mgmt.
            </a>
            <ul class="collapse list-unstyled" id="remmenu">
                <li>
                            <a href="record-income-list.html"><i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;Rec. Income / Expense</a>
                        </li>
                    </ul>
                </li>
           <li>
            <a href="#report" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                <i class="fas fa-user fs-11"></i>&nbsp;
                Reports
            </a>
            <ul class="collapse list-unstyled" id="report">
                <li>
                            <a href="#pg" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;PG and Member Profile
                                </a>
                                <ul class="collapse list-unstyled" id="pg">
                        <li>
                            <a href="overall-pg-summary.html">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;Overall PG Summary
                                </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;PG - Wise Details
                                </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;PG  Member Details
                                </a>
                        </li>
                    </ul>
                        </li>
                        <li>
                            <a href="#buss" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;Business Details
                                </a>
                                <ul class="collapse list-unstyled" id="buss">
                        <li>
                            <a href="#">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;PG Main Commodity
                                </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;Sale Channel & Payment Frequency
                                </a>
                        </li>
                        <li>
                            <a href="commodity-production-surplus.html">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp; Commodity Production & Surplus
                                </a>
                        </li>
                    </ul>
                        </li>
                        <li>
                            <a href="#capital" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;Capital and Costs
                                </a>
                                <ul class="collapse list-unstyled" id="capital">
                        <li>
                            <a href="#">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;Total Fixed Costs Report
                                </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;Variable Cost Report
                                </a>
                        </li>
                    </ul>
                        </li>
                        <li>
                            <a href="#market" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp; Market Information
                                </a>
                                <ul class="collapse list-unstyled" id="market">
                        <li>
                            <a href="#">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;Average Cycle Count
                                </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;Distance to Market Report
                                </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp; Average Rate Report
                                </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;Source of Information Report
                                </a>
                        </li>
                    </ul>
                        </li>
                        <li>
                            <a href="#binfo" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp; Buss. Assumptions & Info.
                                </a>
                                <ul class="collapse list-unstyled" id="binfo">
                        <li>
                            <a href="#">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;Equipment Wise Report
                                </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;Loan Period Report
                                </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;Loan Interest Rate
                                </a>
                        </li>
                    </ul>
                        </li>
                         <li>
                            <a href="#fin" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;Financials
                                </a>
                                <ul class="collapse list-unstyled" id="fin">
                        <li>
                            <a href="#">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;Loan Report
                                </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;Business Plan Report
                                </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp; Source of Loan Report
                                </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp; Source of Capital Report
                                </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;  Type of Support Report
                                </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp; Purpose of Capital
                                </a>
                        </li>
                        <li>
                            <a href="pg-fund-disbursement-report.html">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp; PG Fund Disbursement
                                </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;  Business Initiation Report
                                </a>
                        </li>
                    </ul>
                        </li>
                        <li>
                            <a href="#sales" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;Business Sales
                                </a>
                                <ul class="collapse list-unstyled" id="sales">
                        <li>
                            <a href="pg-turn-over-summary-report.html">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;PG Turn-over Summary Report
                                </a>
                        </li>
                        <li>
                            <a href="pg-member-benefit-report.html">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;PG Member Benefit Report
                                </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp; Mode of Payment Report
                                </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp; Cashbook Usage Report
                                </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;  Sale Reports – Geo & Commodity Wise
                                </a>
                        </li>
                        <li>
                            <a href="#">
                                <i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp; PG Profitability Report
                                </a>
                        </li>
                    </ul>
                        </li>
                    </ul>
                </li>
    </ul>
  
</nav> -->
<div class="sidebar-header" style="position: fixed; top: 0; right: 0;  left: 0; z-index: 1030;">
    <img src="assets/images/nrlm.png" style="margin-left:1%;">
</div>
<div style="position: fixed; top: 7%; right: 83%;  left: 0; overflow: auto;">
<nav id="sidebar"  *ngIf="((getFromPage != 'forgot' && pwdFlag == 'N') || (getFromPage == 'login' && pwdFlag != 'Y'))">
    <ul class="list-unstyled components" id="demo"  style="margin-top: 2%;">
        <ng-container *ngFor="let m of menuData">
            <li>
                <ng-container *ngIf="(m.parent_code == 'MAIN' && m.deny_flag == 'N')">
                    <a [href]="'#'+m.menu_code" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle"
                        aria-controls="adminSubmenu">
                        <i class="fas fa-user fs-11" aria-hidden="true"></i>&nbsp;
                        {{m.menu_desc}}
                    </a>
                    <ul class="collapse list-unstyled" [id]="m.menu_code">
                    <ng-container *ngFor="let c of menuData">
                       
            <li *ngIf="(c.parent_code == m.menu_code && c.deny_flag == 'N')">
                <a (click)='getMenuCode(c)' ><i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;{{c.menu_desc}}</a>
            </li>
        </ng-container>
        </ul>
        </ng-container>

        </li>
        </ng-container>
    </ul>
</nav>
</div>